import { utcToZonedTime as u } from "date-fns-tz";
var i = /* @__PURE__ */ ((e) => (e.ANONYMOUS = "Anonymous", e.ABO = "BUSINESS_OWNER", e.REGISTERED = "CUSTOMER", e.MEMBER = "MEMBER", e.EMPLOYEE = "EMPLOYEE", e))(i || {});
const g = function(e, t) {
  let n = {};
  if (e)
    if (e.SessionService)
      ({ SessionService: n } = e);
    else
      return e.SessionService = n, t(n);
  return n;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(e) {
    let t = {};
    const n = () => ({
      session: t,
      isAnonymous: () => !(t != null && t.type) || (t == null ? void 0 : t.type) === i.ANONYMOUS,
      isRegistered: () => (t == null ? void 0 : t.type) === i.REGISTERED,
      isABO: () => (t == null ? void 0 : t.type) === i.ABO,
      isMember: () => (t == null ? void 0 : t.type) === i.MEMBER,
      isEmployee: () => (t == null ? void 0 : t.type) === i.EMPLOYEE,
      isActor: () => !!t.act
    }), o = (s) => {
      t = Object.assign(t, s);
    };
    return e.getSession = n, e.setSession = o, e;
  }
), S = function(e, t) {
  let n = {};
  if (e)
    if (e.ConfigService)
      ({ ConfigService: n } = e);
    else
      return e.ConfigService = n, t(n);
  return n;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(e) {
    let t = {};
    const n = (s) => {
      const { session: l } = g.getSession();
      let r = { ...t };
      const c = s ?? l.currentCountry;
      return c && (r = {
        ...r,
        ...t[c]
      }), r;
    }, o = (s) => {
      t = Object.assign(t, s);
    };
    return e.getConfigs = n, e.setConfigs = o, e;
  }
), E = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], a = (e) => {
  const { NEXT_PUBLIC_TIMEZONE: t } = S.getConfigs();
  return new Date(u(e, t));
}, M = (e, t = !0, n = !1) => {
  const o = t ? a(e) : new Date(e);
  return `${`${String(o.getDate())} ${E[o.getMonth()]}${n ? "" : ","} ${String(
    o.getFullYear()
  )}`}, ${new Date(o.getTime()).toLocaleTimeString(navigator.language, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: !1
  })}`;
};
export {
  M as $
};
//# sourceMappingURL=commonHelper-b8d5e6e3.mjs.map
